import { Box } from '@chakra-ui/react';

import MetropolisLogo from '@m/assets/svg/wordmark-latest';
import { ArrowBack } from '@m/icons';

interface PayHeaderProps {
  onBack?: () => void;
}

export function PayHeader({ onBack }: PayHeaderProps) {
  return (
    <Box
      borderBottom="1px solid"
      borderColor="stroke.divider.emphasized"
      bg="fill.background.default"
      height="72px"
      display="flex"
      alignItems="center"
      px={4}
      position="relative"
      width="100%"
    >
      {onBack && (
        <Box
          as="button"
          onClick={onBack}
          aria-label="Go back"
          cursor="pointer"
          _hover={{ opacity: 0.7 }}
          transition="opacity 0.2s"
          p={0}
          m={0}
          border="none"
          bg="transparent"
          display="flex"
          alignItems="center"
          justifyContent="center"
          width="32px"
          height="32px"
          flexShrink={0}
          zIndex={10}
        >
          <ArrowBack style={{ fontSize: '24px' }} />
        </Box>
      )}
      <Box position="absolute" left="50%" top="50%" transform="translate(-50%, -50%)">
        <MetropolisLogo width="120px" height="24px" />
      </Box>
    </Box>
  );
}
